"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentChannel = void 0;
const topic_1 = require("../../topic");
const PAYMENTS_CHANNEL = 'payments';
class PaymentChannel {
    constructor(_logger) {
        this._logger = _logger;
        this.channel = PAYMENTS_CHANNEL;
        this.topics = {
            CTA_Cashier_Open: new topic_1.Topic('CTA_Cashier_Open', PAYMENTS_CHANNEL, this._logger),
            CTA_Quick_Deposit: new topic_1.Topic('CTA_Quick_Deposit', PAYMENTS_CHANNEL, this._logger),
        };
    }
}
exports.PaymentChannel = PaymentChannel;
//# sourceMappingURL=payments.channel.js.map